export enum ActivityStatus {
	OK = "OK",
	KO = "KO",
	WAIT = "WAIT"
}

export enum InterruzioneStatus {
	ENDED = "ENDED",
	WAIT = "WAIT"
}

export enum CanaleAccessoEnum {
	CALL_CENTER = "CALLCENTER",
	FRONTOFFICE = "FRONTOFFICE",
	MAIL = "MAIL"
}

export enum TipoPrestazione {
	CALL_CENTER = "CALLCENTER",
	FRONTOFFICE = "FRONTOFFICE",
	MAIL = "MAIL",
	BACKOFFICE = "BACKOFFICE"
}

export enum UserRole {
	ADMIN = "ROLE_ADMIN",
	RESPONSIBLE = "ROLE_RESPONSIBLE",
	SUPERVISOR = "ROLE_SUPERVISOR",
	OPERATOR = "ROLE_OPERATOR",
	REPORT = "ROLE_REPORT",
	UNIFICATORE = "ROLE_UNIFICATORE_ASL",
}

export enum UserRolePrettyName {
	ADMIN = "Amministratore",
	RESPONSIBLE = "Referente di zona",
	SUPERVISOR = "Supervisore",
	OPERATOR = "Operatore",
	REPORT = "Report",
	UNIFICATORE = "Import CUP Unico",
}

export enum PageMode {
	EDIT = "EDIT",
	VIEW = "VIEW",
	NEW = "NEW"
}

export enum TipoInterruzioneCode {
	PERSONALE = "personale",
	DISSERVIZIO = "disservizio"
}

export enum TipoInterruzioneName {
	PERSONALE = "Causa personale",
	DISSERVIZIO = "Causa disservizio sistemico"
}

export enum CausaInterruzioneCode {
	PAUSA = "pausa",
	RITARDO = "ritardo",
	SISTEMI_KO = "sistemiko"
}

export enum CausaInterruzioneName {
	PAUSA = "Pausa",
	RITARDO = "Ritardo",
	SISTEMI_KO = "Sistemi Ko"
}

export interface ConfigDTO {
	id: string;
	prestazioni: PrestazioneDTO[];
	tipologiaInterruzione: string[];
	causaInterruzione: string[];
	createdBy: string;
	createdDate: string;
	lastModifiedBy: string;
	lastModifiedDate: string;
}

export interface ComboBoxDTO {
	key: string;
	value: string;
}

export interface ContattoDTO {
	id: string;
	operatore: string;
	tipoContatto: string;
	paziente: string;
	createdBy: string;
	createdDate: string;
	lastModifiedBy: string;
	lastModifiedDate: string;
	puntoServizioId: string;
	cooperativaId: string;
}

export interface PrestazioneDTO {
	id: string;
	name: string;
	operatore: string;
	codice: string;
	cooperativa: string;
	origin: string;
	type: string;
	startDate: string;
	endDate: string;
	status: string;
	accesso: string;
	subTask: SubTaskDTO[];
	note: string;
	createdBy: string;
	createdDate: string;
	lastModifiedBy: string;
	lastModifiedDate: string;
	description: string;
	duration: number;
	idContatto: string;
	notaStatus: string;
	boOpzionali: string[];
	boObbligatori: string[];
	tipoFrontOffice: string;
	puntoServizioId: string;
	puntoServizioName: string;
	paziente?: string;
}

export interface ContattoPrestazione {
	prestazione: PrestazioneDTO;
	backofficeOpzionali: PrestazioneConfigDTO[];
}

export interface PrestazioneConfigDTO {
	id: string;
	name: string;
	codice: string;
	description: string;
	type: TipoPrestazione;
	subTask: string[];
	codiceFiscalePersona: string;
	nomePersona: string;
	cognomePersona: string;
	dataNascitaPersona: string;
	sessoPersona: string;
	flagInserimento: boolean;
	flagModifica: boolean;
	nre: string;
	numeroPrenotazione: string;
}

export interface SubTaskDTO {
	id: string;
	nota: string;
	status: string;
	description: string;
}

export interface PuntoServizioDTO {
	cooperativa: string,
	createdBy: string,
	createdDate: string,
	id: string,
	indirizzo: string,
	lastModifiedBy: string,
	lastModifiedDate: string,
	name: string,
	puntoServizioConfig: boolean,
	operatori: UserDTO[];
	asl: string;
	telefono: string;
	email: string;
	codiceTemporaneo: string;
	codiceDefinitivo: string;
	action: string;
	cooperativaName: string;
}

export interface PrestazioneFilterDTO {
	statoPrestazione: string[];
	operatore: string;
	codicePrestazione: string;
	date: string;
	tipoPrestazione: string[];
	puntoServizio: string;
}

export interface InterruzioneDTO {
	id: string;
	operatore: string;
	tipologiaInterruzione: string;
	causaInterruzione: string;
	startDateTime: string;
	endDateTime: string;
	duration: number;
	statusInterruzione: string;
	createdBy: string;
	createdDate: string;
	lastModifiedBy: string;
	lastModifiedDate: string;
	puntoServizioId: string;
	cooperativa: string;
	puntoServizioName: string;
}

export interface InterruzioniFilterDTO {
	tipologiaInterruzione: string;
	causaInterruzione: string;
	date: string;
	operatore: string;
	puntoServizioId: string;
}

export interface UserDTO {
	id: string;
	login: string;
	email: string;
	firstname: string;
	lastname: string;
	cooperativa: string;
	authorities: string[];
	createdBy: string;
	createdDate: string;
	lastModifiedBy: string;
	lastModifiedDate: string;
	telefono: string;
	indirizzo: string;
	activated: boolean;
	cooperativaName: string;
	codiceFiscale: string;
	unificazioneAsl: string;
}

export interface PrestazioniPreferitePuntoDTO {
	id: string;
	idPuntoServizio: string;
	prestazioniPreferite: string[];
}

export interface AslDTO {
	id: string;
	name: string;
}

export enum InterruzioneType {
	INIT_INTERRUZ = "INIT_INTERRUZ",
	REG_INTERRUZ_PASS = "REG_INTERRUZ_PASS"
}

export interface ReportFilterDTO {
	asl: string;
	puntoServizioId: string;
	dataInizio: string;
	dataFine: string;
}

export interface ReportPageDTO {
	reportPrestazioniDTO: ReportDataDTO[];
	reportContattiDTO: ReportDataDTO[];
}

export interface ReportDataDTO {
	descrizione: string;
	totalePrestazioni: number;
	totaleContatti: number;
	mediaPrestazioniContatto: number;
	tempoMedioFO: number;
	tempoMedioBO: number;
	tempoMedioContatto: number;
	dati: DatoDTO[];
}

export interface DatoDTO {
	label: string;
	numFO: number;
	numBO: number;
	numContatti: number;
}

export enum TipoReportEnum {
	DEFAULT = "DEFAULT",
	FASCE_ORARIE = "FASCE_ORARIE",
	GIORNO = "GIORNO"
}

export interface ExportFilterDTO {
	type: string;
	tipoFrontoffice: string;
	puntoServizioId: string;
	asl: string;
	dataInizio: string;
	dataFine: string;
}

export interface UnificazioneAslDTO {
	id: string;
	name: string;
	aslList: AslDTO[];
}

export interface CooperativaDTO {
	id: string;
	name: string;
	supervisor: string;
	responsible: string;
}

/* ADIBA */

export interface PersonalInfoDTO {
	cambio_consentito: boolean;
	motivo_diniego_consenso: string;
	id: number;
	codice_fiscale: string;
	cognome: string;
	nome: string;
	data_nascita: string;
	sesso: string;
	luogo_nascita: string;
	luogo_nascita_cod_istat: number;
	stato_cittadinanza: string;
	stato_cittadinanza_cod_istat: string;
	indirizzo_residenza: string;
	comune_residenza: string;
	comune_residenza_cod_istat: number;
	asl_appartenenza: string;
	cognome_medico: string;
	nome_medico: string;
	codice_fiscale_medico: string;
	codice_regionale_medico: string;
	email_medico: string;
	data_inizio_scelta: string;
	data_fine_scelta: string;
	telefono_fisso: string;
	telefono_mobile: string;
}

export interface AmbulatorioDTO {
	codiceISTAT: string;
	comune: string;
	orario: string;
	principale: string;
	segreteria: string;
	telefono: string;
	ubicazione: string;
}

export interface MedicoDTO {
	codice_fiscale: string;
	codice_regionale: string;
	cognome: string;
	deroga_max: string;
	nome: string;
	tipologia: string;
	ambulatorio_principale: AmbulatorioDTO;
}

export interface IncaricoDTO {
	aft: string;
	codice_azienda: string;
	codice_fiscale: string;
	codice_istat_nascita: string;
	codice_regionale: string;
	cognome: string;
	email: string;
	nome: string;
	quota_corrente: number;
	quota_indet: number;
	quota_temp: number;
	telefono: string;
	tipo_incarico: string;
}

export interface MedicoDetailDTO {
	codice_fiscale: string;
	codice_regionale: string;
	cognome: string;
	deroga_max: string;
	nome: string;
	tipologia: string;
	ambulatorio_principale: AmbulatorioDTO;

	ambulatori: AmbulatorioDTO[];
	ambulatoriGruppo: AmbulatorioDTO[];
	incarico: IncaricoDTO;
}

export interface TIdDTO {
	descrizione: string;
}

export interface AmbitoDTO {
	descrizione: string;
	t_id: TIdDTO;
}

export interface IncaricoSceltaMedicoDTO {
	ambito: AmbitoDTO;
	ambulatori: AmbulatorioDTO[];
	codice_fiscale: string;
	codice_regionale: string;
	cognome: string;
	nome: string;
	id: number;
	scelte_disponibili: number;
}

export interface AssistitoDTO {
	codice_fiscale: string;
	cognome: string;
	data_nascita: string;
	luogo_nascita: string;
	nome: string;
	sesso: string;
}

export interface SceltaDTO {
	assistito: AssistitoDTO;
	data_fine: string;
	data_inizio: string;
	incarico: IncaricoSceltaMedicoDTO;
}

export interface SceltaMedicoResponseDTO {
	scelta_chiusura: SceltaDTO;
	scelta_corrente: SceltaDTO;
}
